import { useEffect, useState } from 'react';
import type { RatesSettings } from '@/settings/types';
import { fetchRates, saveRates } from '@/api/rates';
import { RatesEditor } from '@/components/RatesEditor';

export function AdminRatesPage() {
  const [rates, setRates] = useState<RatesSettings | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetchRates();
        if (!cancelled) setRates(r);
      } catch (err) {
        if (!cancelled) setError((err as Error).message || 'Failed to load rates');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8 text-red-700">Error: {error}</div>
    );
  }
  if (!rates) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-8 text-slate-500">Loading…</div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-xl font-semibold text-slate-900 mb-1">CEB rates & settings</h1>
      <p className="text-slate-600 text-sm mb-6">
        Changes take effect immediately for the public calculator. Preview any bill first before
        saving.
      </p>
      <RatesEditor
        initial={rates}
        onSave={async (next) => {
          const saved = await saveRates(next);
          setRates(saved);
        }}
      />
    </div>
  );
}
